export const COMMAND_CENTER_BASE_URL = '/command-center';

const ACTIVITY_BASE_PATH = 'activity';
const COMMISSIONS_BASE_PATH = 'commission-sheet';
const FEEDBACK_BASE_PATH = 'feedback';
const FINANCE_BASE_PATH = 'finance';
const INTERVIEWS_BASE_PATH = 'sendouts/interviews';
const INVENTORY_BASE_PATH = 'inventory';
const PRODUCTION_BASE_PATH = 'production';
const PRODUCTIVITY_BASE_PATH = 'productivity';

export const ENDPOINTS = {
  overallPerformance: `${COMMAND_CENTER_BASE_URL}/overall-performance`,
  overallPerformanceDownload: `${COMMAND_CENTER_BASE_URL}/overall-performance/download`,

  // Activity
  activityHistory: `${ACTIVITY_BASE_PATH}/history`,
  activityPlacementsHistory: `${ACTIVITY_BASE_PATH}/placements/history`,
  activityPlacementsSummary: `${ACTIVITY_BASE_PATH}/placements/summary`,
  activitySendoutsHistory: `${ACTIVITY_BASE_PATH}/sendouts/history`,
  activitySummary: `${ACTIVITY_BASE_PATH}/summary`,
  activityTrendsHistory: `${ACTIVITY_BASE_PATH}/trends/history`,
  activityWeek: `${ACTIVITY_BASE_PATH}/week`,
  activityPhoneCallsHistory: `${ACTIVITY_BASE_PATH}/phones/calls/hourly-trends-history`,
  activityPhoneCallsSummary: `${ACTIVITY_BASE_PATH}/phones/calls/summary`,
  recruitersActivity: '/recruiters/:userId/activities',

  // Interviews
  debriefingCalls: `${INTERVIEWS_BASE_PATH}/debriefing-calls`,
  preparationCalls: `${INTERVIEWS_BASE_PATH}/preparation-calls`,

  // Follow Up Tasks
  unconvertedSendovers: 'sendovers/unconverted',
  unsignedAgreements: 'fee-agreements/unsigned',

  // Users
  tenures: 'users/tenures',

  // Inventory
  inventorySummary: `${INVENTORY_BASE_PATH}/summary`,
  inventorySummaryByType: `${INVENTORY_BASE_PATH}/:type/summary`,

  // Hot Inventory
  hotInventoryStatsSummary: 'urgency-verification/inventories/estimated-comissions',
  hotInventoryCandidates: 'urgency-verification/candidates',
  hotInventoryJobOrders: 'urgency-verification/job-orders',

  // Finance
  financeSummary: `${FINANCE_BASE_PATH}/summary`,
  financeRecruiterSummary: `${FINANCE_BASE_PATH}/recruiters/summary`,
  financeSummaryHistory: `${FINANCE_BASE_PATH}/summary/history`,
  financeHealthSummary: `${FINANCE_BASE_PATH}/health/summary`,

  // Productivity
  productivitySummary: `${PRODUCTIVITY_BASE_PATH}/summary`,
  productivityRecruiter: `${PRODUCTIVITY_BASE_PATH}/recruiter`,
  productivityRecruiterPerformance: `${PRODUCTIVITY_BASE_PATH}/recruiters/performance`,
  downloadProductivityRecruiterPerformance: `${PRODUCTIVITY_BASE_PATH}/recruiters/performance/download`,
  productivityTeam: `${PRODUCTIVITY_BASE_PATH}/team`,
  productivityTeamHeadCount: `${PRODUCTIVITY_BASE_PATH}/team/head-count`,
  productivityWeek: `${PRODUCTIVITY_BASE_PATH}/week`,
  productivityTotals: `${PRODUCTIVITY_BASE_PATH}/totals`,

  // Feedback Notes
  feedbackNotesByEmployee: `${FEEDBACK_BASE_PATH}/v1/notes/employees/:employeeNumber`,
  feedbackNotes: `${FEEDBACK_BASE_PATH}/v1/notes`,
  feedbackNotesById: `${FEEDBACK_BASE_PATH}/v1/notes/:id`,
  reachOutReasons: `${FEEDBACK_BASE_PATH}/v1/reach-out-reasons`,
  addressableIssues: `${FEEDBACK_BASE_PATH}/v1/addressable-issues`,
  supportActivitiesByEmployee: `${FEEDBACK_BASE_PATH}/v1/activities/employees/:employeeNumber`,
  supportActivityById: `${FEEDBACK_BASE_PATH}/v1/activities/:id`,

  // Financial Boards
  commissionsBoardPeriods: `v1/${COMMISSIONS_BASE_PATH}/periods`,
  commissionsBoardSheets: `v1/${COMMISSIONS_BASE_PATH}/`,
  commissionsBoardTransactions: `v1/${COMMISSIONS_BASE_PATH}/transactions`,
  fallOffsBoardHeaders: `${PRODUCTION_BASE_PATH}/falloff-headers`,
  fallOffsByRecruiter: `${PRODUCTION_BASE_PATH}/falloff-by-recruiter`,
  fallOffsByWeek: `${PRODUCTION_BASE_PATH}/falloff-by-week`,
  fallOffsTransactionsByWeek: `${PRODUCTION_BASE_PATH}/falloff-by-transaction/:id`,
  fallOffTransactionsByRecruiter: `${PRODUCTION_BASE_PATH}/falloff-by-recruiter/:id/transaction`,
  productionBoardByWeek: `${PRODUCTION_BASE_PATH}/board-by-week`,
  productionBoardRecruiterByWeek: `${PRODUCTION_BASE_PATH}/recruiter-board-by-week`,
  productionTrackingByRecruiter: `${PRODUCTION_BASE_PATH}/tracking-production-by-recruiter`,
  productionTrackingByTeam: `${PRODUCTION_BASE_PATH}/tracking-production-by-team`,
  productionTransactions: `${PRODUCTION_BASE_PATH}/transactions`,
  productionYearsAvailable: `${PRODUCTION_BASE_PATH}/years`,
  productionYearToDate: `${PRODUCTION_BASE_PATH}/year-to-date`,
  productionYearToDateByRecruiter: `${PRODUCTION_BASE_PATH}/recruiter-year-to-date`,

  // v2 endpoints
  overallPerformanceV2: `${COMMAND_CENTER_BASE_URL}/v2/overall-performance`,
  overallPerformanceDownloadV2: `${COMMAND_CENTER_BASE_URL}/v2/overall-performance/download`
};
